import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import { PlayActionEvent, PlayActionDescription } from './playEvents/PlayAction.style';
import { PlayEventsWrapper } from './PlayEvents.style';
import { TeamLogoWrapper } from './PlayScores.style';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

const { SM_MIN, SM_MAX } = GDBREAKPOINTS;

const {
    mlbGrey2,
    mlbGrey5
} = COLORS;

// TODO: come up with better system for passing colors to this comp.
// Perhaps pass as a prop to Play comp from product config for easy managing / tweaking.
const negativeColor = '#ff0500';
const positiveColor = '#497eac';
const scoreColor = '#008eff';

// TODO: chat with product team about all possible result eventTypes for color maping
const colorMap = {
    home_run: scoreColor,
    single: positiveColor,
    double: positiveColor,
    triple: positiveColor,
    walk: positiveColor,
    intent_walk: positiveColor,
    fielders_choice: positiveColor,
    strikeout: negativeColor,
    field_out: negativeColor,
    grounded_into_double_play: negativeColor,
    grounded_into_triple_play: negativeColor
};

export const PlayResultsEvent = styled(PlayActionEvent)`
    color: ${({ type }) => colorMap[type] || mlbGrey5};
    ${({ isLoading }) => isLoading ? 'padding-bottom: 30px' : ''};
`;

export const PlayResultsDescription = styled(PlayActionDescription)`
    margin: 10px 0;
`;

export const PlayResultsWrapper = styled(PlayEventsWrapper)`
    ${PlayResultsEvent} {
        margin-bottom: 2px;
    }
`;

export const PlayResultsHeadshotWrapper = styled(TeamLogoWrapper)`
    width: 48px;
    height: 48px;
    border: 2px solid var(--gameday-background-color);
    background-color: var(--gameday-background-color);
    img {
        margin-left: 0px;
        margin-top: 0px;
    }
`;

export const HomeRunSubHeader = styled.div`
    font-size: 12px;
    line-height: 20px;
    color: var(--gameday-secondary-font-color);
    font-weight: bold;
    text-transform: uppercase;
`;

export const HomeRunSubText = styled.div`
    font-size: 18px;
    line-height: 20px;
    color: var(--gameday-primary-font-color);
    font-weight: bold;
    
    span {
        font-size: 14px;
        font-weight: 500;
    }
`;

export const HomeRunDetailsWrapper = styled.div`
    display: flex;
    margin-top: 10px;
    justify-content: space-between;

    @media (min-width: ${SM_MIN}) and (max-width: ${SM_MAX}) {
        justify-content: flex-start;

    }
`;

export const HomeRunWrapper = styled.div`
    position: relative;
    flex: 0;
    white-space: nowrap;
    margin-right: 32px;
    
    &:not(:first-child) {
        &:before {
            height: 20px;
            width: 1px;
            position: absolute;
            left: -16px;
            top: calc(50% - 10px);
            background-color: ${mlbGrey2};
            content: '';
        }
}
`;
